import { html, LitElement, TemplateResult } from "lit";
import { query, state } from "lit/decorators.js";
import { styleMap } from "lit/directives/style-map.js";
import { Constructor } from "./common";
import { UsosTooltip } from "../tooltip/usos-tooltip";

export declare interface TooltipMixinInterface {
    tooltipElement: UsosTooltip;
    renderTooltip(): TemplateResult;
}

export const TooltipMixin = <T extends Constructor<LitElement>>(base: T) => {
    class TooltipMixinClass extends base implements TooltipMixinInterface {
        @query('#tooltip') tooltipElement!: UsosTooltip;

        @state() private _showTooltip = false;

        renderTooltip(): TemplateResult {
            const tooltipStyle = { display: this._showTooltip ? null : 'none' };
            return html`
                <usos-tooltip id="tooltip" style=${styleMap(tooltipStyle)}>
                    <slot name='tooltip' @slotchange=${this._onTooltipSlotChange}></slot>
                </usos-tooltip>
            `;
        }

        private _onTooltipSlotChange(e: Event) {
            this._showTooltip = (e.target as HTMLSlotElement).assignedNodes().length > 0;
        }
    }

    return TooltipMixinClass as T & Constructor<TooltipMixinInterface>;
}
